import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastCheck, setLastCheck] = useState(Date.now());

  useEffect(() => {
    const savedToken =
      localStorage.getItem("auth_token") ||
      sessionStorage.getItem("auth_token");
    if (savedToken) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${savedToken}`;
    }
  }, []);

  const login = (data) => {
    if (data.token) {
      const storage = data.rememberMe ? localStorage : sessionStorage;
      storage.setItem("auth_token", data.token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    }
    setAuth(data);
  };

  const logout = useCallback(() => {
    localStorage.removeItem("auth_token");
    sessionStorage.removeItem("auth_token");
    delete axios.defaults.headers.common["Authorization"];
    setAuth(null);
  }, []);

  const refreshAuth = () => setLastCheck(Date.now());

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/user`,
          { withCredentials: true }
        );

        if (res.status === 200 && res.data?.user) {
          const savedToken =
            localStorage.getItem("auth_token") ||
            sessionStorage.getItem("auth_token");

          setAuth({
            role: res.data.user.role,
            userName: res.data.user.userName,
            isEmailVerified: res.data.user.isEmailVerified,
            email: res.data.user.email,
            token: savedToken,
          });
        } else {
          console.log("Auth check failed: respuesta inesperada", res);
          // logout();
        }
      } catch (err) {
        const status = err?.response?.status;
        console.warn("Auth check failed:", status);

        if (status === 401 || status === 403) {
          // logout();
          console.log("Token expirado o inválido, pero no se cerrará sesión automáticamente para evitar problemas de UX. Por favor, vuelva a iniciar sesión.");
        } else {
          setAuth((prev) => prev);
        }
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [lastCheck, logout]);

  return (
    <AuthContext.Provider value={{ auth, login, logout, loading, refreshAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);